(() => {
  if(customElements.get('oc-faq'))return;
  customElements.define('oc-faq',class extends HTMLElement {
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      const items=[...this.querySelectorAll('details')];
      for(const item of items)item.addEventListener('toggle',()=>{if(item.open&&this.dataset.multiple!=='true')for(const other of items)if(other!==item)other.open=false;},options);
      this.addEventListener('shopify:block:select',event=>{const item=items.find(el=>el.dataset.blockId===event.detail.blockId);if(item){item.open=true;item.scrollIntoView({block:'nearest',behavior:'instant'});}},options);
    }
    disconnectedCallback(){this.abort?.abort();}
  });
})();
